/* eslint-disable @typescript-eslint/no-explicit-any */
import AppModal from "../feedBacks/AppModal";
import { CARD_TITLE } from "../../utils/constants";
import { ButtonType } from "../../enums/componentEnums";
import AnimatedInput from "../Inputs/AppAnimatedInput";
import AppButton from "../Inputs/AppButton";
import * as Yup from "yup";
import useCustomFormik from "../../customHooks/useFormik";
import { enqueueSnackbar } from "notistack";
import { usePostData } from "../../customHooks/usePostData";
import { IUser } from "../../utils/interfaces";
import { useQueryClient } from "@tanstack/react-query";

function ChangeUserPasswordModal({
  isModalOpen,
  closeModal,
  enableOutsideClick = true,
  data,
}: {
  isModalOpen: boolean;
  closeModal: () => void;
  enableOutsideClick?: boolean;
  data?: IUser;
}) {
  const queryClient = useQueryClient();
  const initialValues = {
    new_password: "",
    confirm_password: "",
  };
  const validationSchema = Yup.object({
    new_password: Yup.string().required("New password is required"),
    confirm_password: Yup.string()
      .oneOf([Yup.ref("new_password")], "Passwords must match")
      .required("Confirm password is required"),
  });
  const onSubmit = (values: any) => {
    mutate(values);
    // actions.resetForm(); // Reset the form after submission
  };
  const {
    handleSubmit,
    getFieldProps,
    errors,
    touched,
    isSubmitting,
    resetForm,
    setSubmitting,
  } = useCustomFormik({ initialValues, validationSchema, onSubmit });

  const { mutate } = usePostData(`/users/${data?.id}`, "PUT", {
      onSuccess: (data) => {
          
      queryClient.invalidateQueries({
        queryKey: ["/users", "fetchAllUsers", data.company.id],
        exact: false,
      });
      enqueueSnackbar("User password changed successfully!", {
        variant: "success",
      });
      resetForm();
      setSubmitting(false);
      closeModal();
    },
    onError: (err) => {
      console.log("Error occurred:", err);
      const errorMessages = Object.values(err.response?.data || {})
        .flat() // Flatten arrays of errors
        .join(" "); // Join all messages into a single string
      enqueueSnackbar(errorMessages || "Error adding user", {
        variant: "error",
      });
      setSubmitting(false);
    },
  });
  return (
    <AppModal
      isOpen={isModalOpen}
      onClose={closeModal}
      closeOnOutsideClick={enableOutsideClick} // Enable/disable outside click close
    >
      <h2 className={CARD_TITLE}>
        Change {data ? `${data.first_name} ${data.last_name}'s` : "user"}{" "}
        password
      </h2>
      <div className="gap-6 flex flex-col items-start">
        <AnimatedInput
          {...getFieldProps("new_password")}
          placeholder="New Password"
          isErrored={!!errors.new_password}
          isTouched={!!touched.new_password}
          errorMessage={errors.new_password}
        />
        <AnimatedInput
          {...getFieldProps("confirm_password")}
          placeholder="Confirm Password"
          isErrored={!!errors.confirm_password}
          isTouched={!!touched.confirm_password}
          errorMessage={errors.confirm_password}
        />

        <AppButton
          className={"w-full mt-4"}
          text={
            isSubmitting
              ? ""
              : "Save Changes"
          }
          loader={{
            loading: isSubmitting,
            height: 4,
            width: 4,
          }}
          type={ButtonType.PRIMARY}
          handleClick={handleSubmit}
          disabled={isSubmitting}
        />
      </div>
    </AppModal>
  );
}

export default ChangeUserPasswordModal;
